<template>
    <div class="agent-wechat-refund fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">代理商微信退款订单</span>
            <el-form
                inline
                ref="agentWechatRefundOrderForm"
                v-model="agentWechatRefundData"
                class="right themed-form search-form"
                style="height: auto; line-height: 40px"
            >
                <el-form-item>
                    <el-date-picker
                        style="width: 140px"
                        placeholder="下单起始日期"
                        v-model="agentWechatRefundData.startTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item>
                    <span class="text-color">至</span>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        style="width: 140px"
                        placeholder="下单结束日期"
                        v-model="agentWechatRefundData.endTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item label="所属代理商:">
                    <el-select
                        v-model="agentWechatRefundData.agentTreeIdNew"
                        filterable
                        clearable
                    >
                        <el-option
                            v-for="item in agentThreeLists"
                            :key="item.index"
                            :label="item.agentName"
                            :value="item.agentId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input v-model="agentWechatRefundData.agentThreeName" placeholder="所属代理商"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <!-- <el-input v-model="agentWechatRefundData.wechatAgentName" placeholder="下单代理商"></el-input> -->
                    <el-input
                        v-model="agentWechatRefundData.agentName"
                        placeholder="下单代理商"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="agentWechatRefundData.mealName"
                        placeholder="套餐"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="提现">
                    <search-select :optionsMetaAll="withdrawOperators" v-model="agentWechatRefundData.withdraw"></search-select>
                </el-form-item>
                <el-form-item label="返点">
                    <search-select :optionsMetaAll="rebateOperators" v-model="agentWechatRefundData.rebate2"></search-select>
                </el-form-item> -->
                <el-form-item>
                    <el-input
                        v-model="agentWechatRefundData.cardId"
                        placeholder="卡号"
                        class="iccid-width"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="agentWechatRefundData.shortIccid"
                        placeholder="短号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="agentWechatRefundData.orderNumber"
                        placeholder="订单号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        style="width: 140px"
                        placeholder="退款起始日期"
                        v-model="agentWechatRefundData.refundStartTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item>
                    <span class="text-color">至</span>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        style="width: 140px"
                        placeholder="退款结束日期"
                        v-model="agentWechatRefundData.refundEndTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        icon="el-icon-search"
                        type="primary"
                        class="themed-button"
                        @click="onSearch"
                        >查询</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        icon="el-icon-download"
                        class="themed-button"
                        type="info"
                        @click="exportExcel"
                        >导出Excel</el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-popover placement="bottom" trigger="click">
                        <div
                            style="
                                width: 220px;
                                line-height: 22px;
                                overflow-y: auto;
                                max-height: 350px;
                            "
                        >
                            <p style="margin-bottom: 10px">筛选条件</p>
                            <el-checkbox
                                v-model="checkList[0]"
                                style="display: none"
                                >订单号</el-checkbox
                            >
                            <el-checkbox v-model="checkList[1]"
                                >所属代理商</el-checkbox
                            >
                            <el-checkbox v-model="checkList[2]"
                                >所属总代理商</el-checkbox
                            >
                            <el-checkbox v-model="checkList[3]"
                                >iccid号</el-checkbox
                            >
                            <el-checkbox v-model="checkList[4]"
                                >短号</el-checkbox
                            >
                            <el-checkbox v-model="checkList[5]"
                                >接入号</el-checkbox
                            >
                            <el-checkbox v-model="checkList[6]"
                                >套餐类型</el-checkbox
                            >
                            <el-checkbox v-model="checkList[7]"
                                >下单金额</el-checkbox
                            >
                            <el-checkbox v-model="checkList[8]"
                                >支付状态</el-checkbox
                            >
                            <el-checkbox v-model="checkList[9]"
                                >数量</el-checkbox
                            >
                            <el-checkbox v-model="checkList[10]"
                                >是否秒返</el-checkbox
                            >
                            <el-checkbox v-model="checkList[11]"
                                >下单代理商</el-checkbox
                            >
                            <el-checkbox v-model="checkList[12]"
                                >开卡公司</el-checkbox
                            >
                            <el-checkbox v-model="checkList[13]"
                                >来源</el-checkbox
                            >
                            <el-checkbox v-model="checkList[14]"
                                >下单时间</el-checkbox
                            >
                            <el-checkbox v-model="checkList[15]"
                                >充值类型</el-checkbox
                            >
                            <el-checkbox v-model="checkList[16]"
                                >返现</el-checkbox
                            >
                            <el-checkbox v-model="checkList[17]"
                                >佣金</el-checkbox
                            >
                            <el-checkbox v-model="checkList[18]"
                                >退款时间</el-checkbox
                            >
                            <el-checkbox v-model="checkList[19]"
                                >退款金额</el-checkbox
                            >
                            <el-checkbox v-model="checkList[20]"
                                >退款理由</el-checkbox
                            >
                            <el-checkbox v-model="checkList[21]"
                                >套餐名称</el-checkbox
                            >
                            <el-checkbox v-model="checkList[22]"
                                >退款操作人</el-checkbox
                            >
                        </div>
                        <el-button
                            slot="reference"
                            icon="el-icon-finished"
                        ></el-button>
                    </el-popover>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <el-table
                ref="table"
                border
                stripe
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :max-height="maxTableHeight"
            >
                <el-table-column
                    v-if="checkList[0]"
                    prop="orderNumber"
                    label="订单号"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[1]"
                    :show-overflow-tooltip="true"
                    prop="agentThreeName"
                    label="所属代理商"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[2]"
                    :show-overflow-tooltip="true"
                    prop="agentName"
                    label="所属总代理商"
                    min-width="120"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[11]"
                    :show-overflow-tooltip="true"
                    prop="wechatAgentName"
                    label="下单代理商"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[3]"
                    label="卡号"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-link :underline="false" type="primary">{{
                            scope.row.cardId
                        }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="checkList[4]"
                    :show-overflow-tooltip="true"
                    prop="shortIccid"
                    label="短号"
                    min-width="120"
                />
                <el-table-column
                    v-if="checkList[5]"
                    :show-overflow-tooltip="true"
                    prop="phone"
                    label="接入号"
                    min-width="120"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[21]"
                    :show-overflow-tooltip="true"
                    prop="mealName"
                    label="套餐名称"
                    min-width="170"
                >
                </el-table-column>

                <el-table-column
                    v-if="checkList[6]"
                    :show-overflow-tooltip="true"
                    prop="mealTypeStr"
                    label="套餐类型"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[7]"
                    prop="orderMoney"
                    label="下单金额"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[8]"
                    label="支付状态"
                    width="100"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.payStatus == 1">已支付</span>
                        <span v-else-if="scope.row.payStatus == 2">待支付</span>
                        <span v-else-if="scope.row.payStatus == 3">已取消</span>
                        <span v-else-if="scope.row.payStatus == 4">已退款</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="checkList[19]"
                    prop="refundFee"
                    label="退款金额"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[20]"
                    prop="refundReason"
                    label="退款理由"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[9]"
                    prop="orderCount"
                    label="数量"
                    min-width="50"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[12]"
                    prop="accountName"
                    label="开卡公司"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[16]"
                    prop="rebate2Money"
                    label="返现"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[17]"
                    prop="commissionMoney"
                    label="佣金"
                    min-width="100"
                >
                </el-table-column>

                <el-table-column
                    v-if="checkList[13]"
                    prop="typeStr"
                    label="卡来源"
                    min-width="80"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[14]"
                    prop="createTime"
                    label="下单时间"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[15]"
                    label="充值类型"
                    min-width="98"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isFirstRecharge == 1"
                            >首次充值</span
                        >
                        <span v-else-if="scope.row.isFirstRecharge == 2"
                            >续费充值</span
                        >
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="checkList[18]"
                    prop="refundTime"
                    label="退款时间"
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    v-if="checkList[22]"
                    prop="refundCreateUserName"
                    label="退款操作人"
                    min-width="120"
                >
                </el-table-column>
                <!-- <el-table-column
                label="操作"
                width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" class="themed-button" type="primary" @click="handleShowDetail(scope.row.id)">详情</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                style="text-align: left; margin-top: 20px"
                background
                layout="total,sizes,prev, pager, next,jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
            ></el-pagination>
        </div>

        <el-dialog
            title="订单详情"
            :visible.sync="dialogDetailVisible"
            :destroy-on-close="true"
        >
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">订单号</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.orderNumber }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">代理商名称</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.agentName }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">卡号</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.cardId }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">短号</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.shortIccid }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">套餐名称</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.mealName }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">套餐类型</div></el-col
                >
                <el-col :span="12">
                    <!-- <div v-if="detailInfo.mealType==1">月卡叠加包</div>
            <div v-else-if="detailInfo.mealType==2">月卡续费</div>
            <div v-else-if="detailInfo.mealType==3">年卡叠加包</div>
            <div v-else-if="detailInfo.mealType==4">年卡续费</div> -->
                    <div>{{ _getMealType(detailInfo.mealType) }}</div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">用户支付金额</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.orderMoney }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">支付状态</div></el-col
                >
                <el-col :span="12"
                    ><div v-if="detailInfo.payStatus == 1">已支付</div>
                    <div v-else-if="detailInfo.payStatus == 2">待支付</div>
                    <div v-else-if="detailInfo.payStatus == 3">已取消</div>
                    <div v-else-if="detailInfo.payStatus == 4">已退款</div>
                    <div v-else>退款中</div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">数量</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.orderCount }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">开卡公司</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.accountName }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">卡来源</div></el-col
                >
                <el-col :span="12"
                    ><div v-if="detailInfo.type == 1">电信</div>
                    <div v-else-if="detailInfo.type == 2">其他卡务</div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">返现金额</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.money }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12"
                    ><div class="dialog-row-label">下单时间</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.createTime }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20" v-if="detailInfo.payStatus == 4">
                <el-col :span="12"
                    ><div class="dialog-row-label">退款理由</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.refundReason }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20" v-if="detailInfo.payStatus == 4">
                <el-col :span="12"
                    ><div class="dialog-row-label">退款时间</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.refundTime }}</div></el-col
                >
            </el-row>
            <el-row :gutter="20" v-if="detailInfo.payStatus == 4">
                <el-col :span="12"
                    ><div class="dialog-row-label">退款操作人</div></el-col
                >
                <el-col :span="12"
                    ><div>{{ detailInfo.refundCreateUserName }}</div></el-col
                >
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="dialogDetailVisible = false"
                    >关闭</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import storage from "@/utils/storage.js";
import SearchSelect from "@/components/SearchSelect.vue";
import { agentListForUser } from "@/api/cardManagement/cardBill.js";
import {
    weChatOrderDetailInfo,
    exportWeixinRefundOrder,
    agentwechatorder,
    weChatRefundOrder,
} from "@/api/order.js";
import resize from "@/mixins/resize.js";
import dictGroup from "@/mixins/dictGroup.js";
export default {
    name: "agentWechatRefund",
    components: { SearchSelect },
    mixins: [resize, dictGroup],
    data() {
        return {
            agentWechatRefundData: {
                payStatus: "4",
                startTime: "",
                endTime: "",
                agentThreeName: "",
                agentTreeIdNew: "",
                wechatAgentName: "",
                mealName: "",
                withdraw: "",
                rebate2: "",
                cardId: "",
                orderNumber: "",
                refundStartTime: "",
                refundEndTime: "",
                shortIccid: "",
            },
            agentThreeLists: [],
            withdrawOperators: [
                { label: "全部", value: "" },
                { label: "不可提现", value: "0" },
                { label: "可提现", value: "1" },
            ],
            rebateOperators: [
                { label: "全部", value: "" },
                { label: "不可返点", value: "0" },
                { label: "可返点", value: "1" },
            ],
            tableData: [],
            page: 1,
            pageSize: 15,
            total: 0,
            dialogDetailVisible: false,
            detailInfo: {
                orderNumber: "",
                agentName: "",
                cardId: "",
                mealName: "",
                mealType: "",
                orderMoney: "",
                payStatus: "",
                orderCount: "",
                accountName: "",
                type: "",
                money: "",
                createTime: "",
                refundReason: "",
                refundTime: "",
                refundCreateUserName: "",
                shortIccid: "",
            },
            checkList: [],
        };
    },
    created() {
        this.getAgentListForUser();
        this.getAgentWeChatRefundOrderList();
        // 初始化筛选（23项，索引0-22）
        const defaultList = [];
        for (let i = 0; i < 23; i++) defaultList.push(true);
        if (storage && storage.support) {
            const saved = storage.get("agentWechatRefundList");
            if (saved) {
                try {
                    const parsed = JSON.parse(saved);
                    // 兼容旧数据：补充缺失的项
                    if (parsed.length === 21) {
                        // 21项：补充套餐名称、退款操作人
                        parsed.push(true, true);
                        this.checkList = parsed;
                        storage.set(
                            "agentWechatRefundList",
                            JSON.stringify(parsed)
                        );
                    } else if (parsed.length === 23) {
                        this.checkList = parsed;
                    } else {
                        this.checkList = defaultList;
                        storage.set(
                            "agentWechatRefundList",
                            JSON.stringify(defaultList)
                        );
                    }
                } catch (e) {
                    this.checkList = defaultList;
                    storage.set(
                        "agentWechatRefundList",
                        JSON.stringify(defaultList)
                    );
                }
            } else {
                this.checkList = defaultList;
                storage.set(
                    "agentWechatRefundList",
                    JSON.stringify(defaultList)
                );
            }
        } else {
            this.checkList = defaultList;
        }
    },
    watch: {
        checkList(newVal) {
            if (storage && storage.support) {
                storage.set("agentWechatRefundList", JSON.stringify(newVal));
            }
        },
    },
    methods: {
        getAgentListForUser() {
            agentListForUser().then((res) => {
                console.log(391);
                this.agentThreeLists = res;
            });
        },
        getAgentWeChatRefundOrderList() {
            let params = {
                pageSize: this.pageSize,
                pageNo: this.page,
            };
            Object.assign(this.agentWechatRefundData, params);
            weChatRefundOrder(this.agentWechatRefundData).then((res) => {
                // agentwechatorder(this.agentWechatRefundData).then(res=>{
                this.tableData = res.rows;
                this.total = res.count;
            });
        },
        onSearch() {
            this.page = 1;
            this.getAgentWeChatRefundOrderList();
        },
        exportExcel() {
            let params = Object.assign({}, this.agentWechatRefundData);
            params.includeFields = this.checkList.join(",");
            exportWeixinRefundOrder(params).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导出成功，请到导出记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.$router.push("/tob/i_export_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },
        onPageChange(page) {
            this.page = page;
            this.getAgentWeChatRefundOrderList();
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getAgentWeChatRefundOrderList();
        },
        handleShowDetail(id) {
            this.dialogDetailVisible = true;
            let params = {
                id: id,
            };
            weChatOrderDetailInfo(params).then((res) => {
                let result = res.entity;
                this.detailInfo.orderNumber = result.orderNumber;
                this.detailInfo.agentName = result.agentName;
                this.detailInfo.cardId = result.cardId;
                this.detailInfo.mealName = result.mealName;
                this.detailInfo.mealType = result.mealType;
                this.detailInfo.orderMoney = result.orderMoney;
                this.detailInfo.payStatus = result.payStatus;
                this.detailInfo.orderCount = result.orderCount;
                this.detailInfo.accountName = result.accountName;
                this.detailInfo.type = result.type;
                this.detailInfo.money = result.money;
                this.detailInfo.createTime = result.createTime;
                this.detailInfo.refundReason = result.refundReason;
                this.detailInfo.refundTime = result.refundTime;
                this.detailInfo.refundCreateUserName =
                    result.refundCreateUserName;
                this.detailInfo.shortIccid = result.shortIccid;
            });
        },
    },
};
</script>
<style>
.agent-wechat-refund .el-form-item__label {
    vertical-align: top;
}
.agent-wechat-refund .dialog-row-label {
    text-align: right;
}
</style>